import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "model-not-found text-center py-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_icon, {
      size: "64",
      color: "grey-lighten-1",
      class: "mb-6"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("mdi-robot-confused-outline", -1)
      ]))]),
      _: 1
    }),
    _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "not-found-title mb-4" }, "Model Not Found", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "not-found-text mb-8" }, " The model you're looking for doesn't exist or may have been removed. ", -1)),
    _createVNode(_component_v_btn, {
      variant: "outlined",
      color: "#5539EC",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'models' })))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { left: "" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("mdi-arrow-left", -1)
          ]))]),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" Back to All Models ", -1))
      ]),
      _: 1
    })
  ]))
}